import { useEffect, useRef } from "react";
import mapboxgl from 'mapbox-gl';

// styles
import "mapbox-gl/dist/mapbox-gl.css";
import styles from "./index.module.scss";
import classNames from "classnames/bind";
const cn = classNames.bind(styles);

const BannerContact = ({
  title,
  text
}) => {

  const mapContainerRef = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    mapboxgl.accessToken = 'pk.eyJ1IjoiZW5yaWNvYmV2aWxhY3F1YSIsImEiOiJjbTI0aHYxbDIwZmswMmtxc2xndnhrdWh3In0.jf9oBw2SIfYkPSaZo0LqqA';

    const markerCoordinates = [12.6600607, 45.9595500];

    if (mapContainerRef.current && !mapRef.current) {
      const map = new mapboxgl.Map({
        container: mapContainerRef.current,
        style: 'mapbox://styles/mapbox/streets-v12',
        center: markerCoordinates,
        zoom: 16
      });

      mapRef.current = map;

      map.on('load', () => {
        new mapboxgl.Marker()
          .setLngLat(markerCoordinates)
          .addTo(map);
      });
    }

    return () => {
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
      }
    };
  }, []);

  return (
    <div className={cn("wrapper")}>
      <div className={cn("container")}>
        <div className={cn("content")}>
          <div className={cn("title")}>
            <h1>{title}</h1>
          </div>
          <div className={cn("text")}>
            <p>{text}</p>
          </div>
          <div className={cn("contacts")}>
            <span>Telefono: <a href="tel:+390434208295">+39 0434 208295</a></span>
            <span>Email: <a href="mailto:segreteria@slbf.it">segreteria@slbf.it</a></span>
            <span>Piazza Ellero Enea dei Mille, 6 Pordenone - 33170</span>
          </div>
        </div>
        <div className={cn("map")} ref={mapContainerRef} style={{ width: '100%', height: '580px' }}></div>
      </div>
    </div>
  );
};

export default BannerContact;
